import { Skeleton } from '@machobear/design-system'

import useSessionComplete from '@/hooks/use-session-complete'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

import MaplibrePopup from './maplibre-popup'
import SingleUnit from './single-unit'
import SingleUnitBlurred from './single-unit-blurred'

const ListingMapPopup = ({
  data,
  latitude,
  longitude,
  onClose,
  isCardLocked = false
}) => {
  const isLoggedIn = useSessionComplete()

  const { isLoading: isLoadingAgreements } = useTermsDialogContext()

  if (isLoadingAgreements && isLoggedIn)
    return <Skeleton.Shape width={240} height={210} />

  return (
    <MaplibrePopup latitude={latitude} longitude={longitude} onClose={onClose}>
      {isCardLocked ? (
        <SingleUnitBlurred listing={data} isLoggedIn={isLoggedIn} />
      ) : (
        <SingleUnit data={data} />
      )}
    </MaplibrePopup>
  )
}
export default ListingMapPopup
